import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Tabs extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        current: PropTypes.number,
        handleChangeTab: PropTypes.func,
    };

    state = {
        newArr: this.props.content,
    };

    handleMouseOver = e => {
        const { handleChangeTab } = this.props;
        const index = e.currentTarget.getAttribute('data-index');
        const newArr = this.props.content[index];

        handleChangeTab(parseInt(index), newArr);
    };

    render() {
        const { content, current } = this.props;

        return (
            <ul className={styles.tabs}>
                {content.map((item, index) => (
                    <li
                        key={index}
                        data-index={index}
                        className={index === current ? styles.active : null}
                        onMouseOver={this.handleMouseOver}>
                        <a href={item.url} target="_blank">
                            {item.title}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(Tabs);
